module.exports = __webpack_public_path__ + "static/img/3.8cba474.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/downloadImg/3.png
// module id = Jozd
// module chunks = 1